import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../../components/icon';
var IconEye = React.forwardRef(function (props, ref) {
  return React.createElement(Icon, _extends({}, props, {
    content: {
      "16": {
        "height": 16,
        "width": 16,
        "source": "<path d=\"M8 14C3.48 14 .28 8.72.14 8.49a1 1 0 0 1 0-1C.28 7.24 3.49 2 8 2s7.72 5.26 7.86 5.49a1 1 0 0 1 0 1C15.72 8.74 12.51 14 8 14zM2.2 8C3 9.17 5.32 12 8 12s5-2.82 5.8-4C13 6.82 10.68 4 8 4S3 6.8 2.2 8z\"></path><ellipse cx=\"8\" cy=\"8\" rx=\"2.01\" ry=\"2\"></ellipse>"
      },
      "24": {
        "height": 24,
        "width": 24,
        "source": "<circle cx=\"12\" cy=\"12\" r=\"3.5\"></circle><path d=\"M23.45 11.11a3.24 3.24 0 0 1-.7-.55l-.33-.47C20.76 7.87 17.14 4 12 4S3.24 7.87 1.61 10.05l-.33.47a3.13 3.13 0 0 1-.7.55 1 1 0 0 0 0 1.78 3.24 3.24 0 0 1 .7.55l.33.47C3.24 16.13 6.86 20 12 20s8.76-3.87 10.39-6l.33-.47a3.13 3.13 0 0 1 .7-.55 1 1 0 0 0 0-1.78zM12 18c-4.86 0-8.29-4.48-9.32-6 1-1.52 4.45-6 9.32-6s8.29 4.48 9.32 6c-1.03 1.52-4.45 6-9.32 6z\"></path>"
      }
    },
    ref: ref
  }));
});
IconEye.displayName = 'IconEye';
IconEye.defaultProps = {
  size: 16
};
export default IconEye;